import Survey from "./survey.container";

export default Survey;
